import React from 'react';
import PropTypes from 'prop-types';
import { PulseBadge } from '../styles/navigationStyles';

/**
 * Renderiza um ícone de navegação com badge opcional
 * @param {Object} props
 * @param {Object} props.item - Item de navegação
 * @param {boolean} props.showBadge - Se deve mostrar o badge
 * @returns {JSX.Element}
 */
export const NavigationIcon = ({ item, showBadge = false }) => {
  const IconComponent = item.icon;
  const icon = <IconComponent aria-hidden="true" />;

  if (showBadge || item.showBadge) {
    return (
      <PulseBadge variant="dot" color="error">
        {icon}
      </PulseBadge>
    );
  }

  return icon;
};

NavigationIcon.propTypes = {
  item: PropTypes.shape({
    icon: PropTypes.elementType.isRequired,
    showBadge: PropTypes.bool,
  }).isRequired,
  showBadge: PropTypes.bool,
};